import React, { useCallback } from 'react'

import {
  ArrowLeft,
  ArrowRight,
  AttentionOutlined,
  Button,
  Icon,
  Modal,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, node, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import { TIER } from '../../constants'
import StatusBanner from '../StatusBanner'

function ReasonStep({
  isOpen,
  onClose,
  onBack,
  onContinue,
  isContinueDisabled = false,
  showBackButton = false,
  showAccessUntilNotice = false,
  accessUntilFormatted = null,
  reasonSelect,
  locale = 'en',
  tier = TIER.ESSENTIALS,
}) {
  const accessNoticeKey = tier === TIER.AI_STUDIO ? 'no_fee_description_ai' : 'no_fee_description'
  const translate = useCallback(
    (key, options = {}) => I18n.t(
      `subscription_management.cancel_modal.${key}`,
      { ns: 'rails', lng: locale, ...options }
    ),
    [locale]
  )

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={translate('title')}
      width="small"
      canClose
      customClass="cancel-subscription-modal"
      footer={(
        <div className="cancel-subscription-modal__step-footer">
          {showBackButton && (
            <Button
              type="ghost"
              size="small"
              actionType="button"
              icon={<Icon svgComponent={ArrowLeft} size="tiny" color="dark" />}
              onClick={onBack}
            >
              {translate('back_button')}
            </Button>
          )}
          <Button
            type="ghost"
            size="small"
            actionType="button"
            customClass="cancel-subscription-modal__step-continue"
            trailIcon={<Icon svgComponent={ArrowRight} size="tiny" color="dark" />}
            onClick={onContinue}
            disabled={isContinueDisabled}
          >
            {translate('continue_button')}
          </Button>
        </div>
      )}
    >
      <div className="cancel-subscription-modal__body">
        {showAccessUntilNotice && (
          <StatusBanner
            icon={AttentionOutlined}
            description={translate(accessNoticeKey, {
              date: accessUntilFormatted,
            })}
            variant="attention"
          />
        )}
        {reasonSelect}
      </div>
    </Modal>
  )
}

ReasonStep.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onBack: func.isRequired,
  onContinue: func.isRequired,
  isContinueDisabled: bool,
  showBackButton: bool,
  showAccessUntilNotice: bool,
  accessUntilFormatted: string,
  reasonSelect: node.isRequired,
  locale: string,
  tier: string,
}

export default ReasonStep
